"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeNames = void 0;
const Exps = __importStar(require("../exp"));
function freeNames(boundNames, exp) {
    switch (exp["@kind"]) {
        case "Var": {
            return boundNames.has(exp.name) ? new Set() : new Set([exp.name]);
        }
        case "Pi": {
            return new Set([
                ...freeNames(boundNames, exp.argType),
                ...freeNames(new Set([...boundNames, exp.name]), exp.retType),
            ]);
        }
        case "PiImplicit": {
            return new Set([
                ...freeNames(boundNames, exp.argType),
                ...freeNames(new Set([...boundNames, exp.name]), exp.retType),
            ]);
        }
        case "PiUnfolded": {
            return freeNames(boundNames, Exps.foldPi(exp.bindings, exp.retType));
        }
        case "Ap": {
            return new Set([
                ...freeNames(boundNames, exp.target),
                ...freeNames(boundNames, exp.arg),
            ]);
        }
        case "ApImplicit": {
            return new Set([
                ...freeNames(boundNames, exp.target),
                ...freeNames(boundNames, exp.arg),
            ]);
        }
        case "ApUnfolded": {
            return freeNames(boundNames, Exps.foldAp(exp.target, exp.args));
        }
        case "Fn": {
            return new Set([
                ...freeNames(new Set([...boundNames, exp.name]), exp.ret),
            ]);
        }
        case "FnAnnotated": {
            return new Set([
                ...freeNames(new Set(boundNames), exp.argType),
                ...freeNames(new Set([...boundNames, exp.name]), exp.ret),
            ]);
        }
        case "FnImplicit": {
            return new Set([
                ...freeNames(new Set([...boundNames, exp.name]), exp.ret),
            ]);
        }
        case "FnImplicitAnnotated": {
            return new Set([
                ...freeNames(new Set(boundNames), exp.argType),
                ...freeNames(new Set([...boundNames, exp.name]), exp.ret),
            ]);
        }
        case "FnUnfolded": {
            return freeNames(boundNames, Exps.foldFn(exp.bindings, exp.ret));
        }
        case "FnUnfoldedWithRetType": {
            return freeNames(boundNames, Exps.foldFnWithRetType(exp.bindings, exp.retType, exp.ret));
        }
        case "Sigma": {
            return new Set([
                ...freeNames(boundNames, exp.carType),
                ...freeNames(new Set([...boundNames, exp.name]), exp.cdrType),
            ]);
        }
        case "SigmaUnfolded": {
            return freeNames(boundNames, Exps.foldSigma(exp.bindings, exp.cdrType));
        }
        case "Cons": {
            return new Set([
                ...freeNames(boundNames, exp.car),
                ...freeNames(boundNames, exp.cdr),
            ]);
        }
        case "Quote": {
            return new Set();
        }
        case "ClazzNull": {
            return new Set();
        }
        case "ClazzCons": {
            return new Set([
                ...freeNames(boundNames, exp.propertyType),
                ...freeNames(new Set([...boundNames, exp.localName]), exp.rest),
            ]);
        }
        case "ClazzFulfilled": {
            return new Set([
                ...freeNames(boundNames, exp.propertyType),
                ...freeNames(boundNames, exp.property),
                ...freeNames(new Set([...boundNames, exp.localName]), exp.rest),
            ]);
        }
        case "ClazzUnfolded": {
            return freeNames(boundNames, Exps.foldClazz(exp.bindings, exp.name));
        }
        case "Objekt": {
            return new Set(Object.values(exp.properties).flatMap((property) => Array.from(freeNames(boundNames, property))));
        }
        case "ObjektUnfolded": {
            return new Set(exp.properties.flatMap((property) => Array.from(freeNames(boundNames, property.exp))));
        }
        case "New": {
            return new Set(Object.values(exp.properties).flatMap((property) => Array.from(freeNames(boundNames, property))));
        }
        case "NewUnfolded": {
            return new Set(exp.properties.flatMap((property) => Array.from(freeNames(boundNames, property.exp))));
        }
        case "NewAp": {
            return new Set(exp.args.flatMap((arg) => Array.from(freeNames(boundNames, arg.exp))));
        }
        case "Dot": {
            return new Set([...freeNames(boundNames, exp.target)]);
        }
        case "SequenceLet": {
            return new Set([
                ...freeNames(boundNames, exp.exp),
                ...freeNames(new Set([...boundNames, exp.name]), exp.ret),
            ]);
        }
        case "SequenceLetThe": {
            return new Set([
                ...freeNames(boundNames, exp.exp),
                ...freeNames(boundNames, exp.type),
                ...freeNames(new Set([...boundNames, exp.name]), exp.ret),
            ]);
        }
        case "SequenceCheck": {
            return new Set([
                ...freeNames(boundNames, exp.exp),
                ...freeNames(boundNames, exp.type),
                ...freeNames(boundNames, exp.ret),
            ]);
        }
        case "SequenceUnfolded": {
            return freeNames(boundNames, Exps.foldSequence(exp.bindings, exp.ret));
        }
        case "MacroEmbedded": {
            return freeNames(boundNames, exp.macro.expand());
        }
    }
}
exports.freeNames = freeNames;
//# sourceMappingURL=freeNames.js.map